/**
 * Prefstest Comparison Table — scroll indicator for table variant.
 * Adds shadow hints when the table overflows horizontally,
 * signalling to the user that there is more content to scroll.
 */
(function () {
  'use strict';

  var SCROLL_CLASS_LEFT = 'prefstest-ct__scroll-wrap--left';
  var SCROLL_CLASS_RIGHT = 'prefstest-ct__scroll-wrap--right';

  function updateScrollHints(wrap) {
    var scrollLeft = wrap.scrollLeft;
    var maxScroll = wrap.scrollWidth - wrap.clientWidth;

    // Can scroll left?
    if (scrollLeft > 1) {
      wrap.classList.add(SCROLL_CLASS_LEFT);
    } else {
      wrap.classList.remove(SCROLL_CLASS_LEFT);
    }

    // Can scroll right?
    if (maxScroll - scrollLeft > 1) {
      wrap.classList.add(SCROLL_CLASS_RIGHT);
    } else {
      wrap.classList.remove(SCROLL_CLASS_RIGHT);
    }
  }

  function init(wrap) {
    updateScrollHints(wrap);
    wrap.addEventListener('scroll', function () {
      updateScrollHints(wrap);
    }, { passive: true });
  }

  // Init all existing scroll wraps
  document.querySelectorAll('[data-prefstest-ct-scroll]').forEach(init);

  // Re-scan for new sections injected by the theme editor
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        if (nodes[j].nodeType === 1) {
          var wraps = nodes[j].querySelectorAll
            ? nodes[j].querySelectorAll('[data-prefstest-ct-scroll]')
            : [];
          wraps.forEach(init);
          if (nodes[j].matches && nodes[j].matches('[data-prefstest-ct-scroll]')) {
            init(nodes[j]);
          }
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
